import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dealer-invoice-import-dialog" }
const _hoisted_2 = { class: "upload-area" }
const _hoisted_3 = { class: "action-links" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"8px","color":"#666","font-size":"12px"} }, " 导入开票信息：经销商编码、销售组织编码、发票抬头、纳税人识别号等为必填项；仅支持 .xlsx / .xls 格式。 ", -1)
const _hoisted_5 = {
  key: 0,
  class: "validate-result",
  style: {"margin-top":"12px"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"600","margin-bottom":"8px"} }, "导入结果", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oio_button = _resolveComponent("oio-button")!
  const _component_UploadOutlined = _resolveComponent("UploadOutlined")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_oio_modal = _resolveComponent("oio-modal")!

  return (_openBlock(), _createBlock(_component_oio_modal, {
    visible: _ctx.dialogVisible,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialogVisible) = $event)),
    title: "批量导入开票信息",
    width: "720px",
    "confirm-loading": _ctx.importLoading,
    "ok-text": "开始导入",
    "enter-callback": _ctx.handleImportConfirm,
    "cancel-callback": _ctx.handleClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_component_oio_button, {
              onClick: _ctx.handleDownloadTemplate,
              loading: _ctx.templateLoading
            }, {
              default: _withCtx(() => [
                _createTextVNode("下载模板")
              ]),
              _: 1
            }, 8, ["onClick", "loading"]),
            _createVNode(_component_FileUpload, {
              value: _ctx.fileValue,
              limit: 1,
              accept: ".xlsx,.xls",
              onChange: _ctx.handleFileChange,
              onRemove: _ctx.handleFileRemove
            }, {
              default: _withCtx(() => [
                _createVNode(_component_oio_button, { type: "primary" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_UploadOutlined),
                    _createTextVNode(" 选择文件 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value", "onChange", "onRemove"])
          ]),
          _hoisted_4
        ]),
        (_ctx.resultMessages.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_a_table, {
                columns: _ctx.messageColumns,
                "data-source": _ctx.resultMessages,
                pagination: false,
                size: "small",
                bordered: "",
                scroll: { y: 220 }
              }, {
                bodyCell: _withCtx(({ column, record }) => [
                  (column.key === 'level')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        style: _normalizeStyle({ color: record.level === 'ERROR' ? '#ff4d4f' : record.level === 'WARN' ? '#faad14' : '#52c41a' })
                      }, _toDisplayString(record.level === 'ERROR' ? '错误' : record.level === 'WARN' ? '警告' : '成功'), 5))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["columns", "data-source"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["visible", "confirm-loading", "enter-callback", "cancel-callback"]))
}